import axios from 'axios';
import moment from 'moment';

const API_URL = process.env.REACT_APP_API_URL;
const CROSS_SELLING_REPORT_URL = `${API_URL}/api/bi/cross-selling-report/`;

export interface CrossSellingReportRow {
  id: number;
  order_id: number;
  order_code: string;
  date: string;
  agent_id: number;
  agent: string;
  product: string;
  units: number;
  value: string;
}

interface GetCrossSellingReportParams {
  since: Date;
  until: Date;
  agent?: number;
}

export function getCrossSellingReport({
  since,
  until,
  agent,
}: GetCrossSellingReportParams): Promise<{ data: CrossSellingReportRow[] }> {
  const params = new URLSearchParams();
  params.set('start_date', moment(since).format('YYYY-MM-DD'));
  params.set('end_date', moment(until).format('YYYY-MM-DD'));
  if (agent) params.set('agent', agent.toString());

  return axios.get<CrossSellingReportRow[]>(
    `${CROSS_SELLING_REPORT_URL}?${params.toString()}`
  );
}
